// src/pages/Contact.tsx
import React, { useState } from "react";
import emailjs from "@emailjs/browser";

import SEO from "../components/SEO";
import { seoConfig } from "../seoConfig";

import about1 from '../assets/images/about/07.png';

const Contact: React.FC = () => {

const seo = seoConfig.contact; // ✅ Load meta for this page



  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    services: "", // ✅ Array se string me convert kiya
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(null);
    setError(null);

    emailjs
      .send(
        "service_igwbl98", // ✅ apna service ID daalo
        "template_zrmkucu", // ✅ apna template ID daalo
        {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          services: formData.services,
          message: formData.message,
          time: new Date().toLocaleString(),
        },
        "ZrBI3N7WfIR50L3Jt" // ✅ apna public key daalo
      )
      .then(() => {
        setSuccess("✅ Your message has been sent successfully!");
        setFormData({ name: "", email: "", phone: "", services: "", message: "" });
      })
      .catch(() => {
        setError("❌ Failed to send your message. Please try again.");
      })
      .finally(() => setLoading(false));
  };

  return (


<>



      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url={seo.url}
        image={seo.image}
      />



{/* rts bread crumba rea start */}
  <div className="rts-breadcrumb-area-contact bg_image">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="baread-crumb-main-wrapper pt--100">
            <div className="inner">
              <h1 className="title rts_hero__title">Contact Us</h1>
              <span className="bg-text d-none d-md-inline">Manikarn Digital</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* rts bread crumba rea end */}



    
      {/* ==== contact start ==== */}
      <section className="contact-m fade-wrapper pt--60 pb--60">
        <div className="container">


{/* ==== banner start ==== */}
  <div className="contact-section">
        <div className="projects-s__single topy-tilt">

      <div className="container mt--110 mt-md--50 mt-sm--30 contact-bg">
      <div className="row align-items-center">
        {/* Text Column - 1st on desktop, 2nd on mobile */}
        <div className="col-lg-4 order-2 order-lg-1">
            <div className="col-12 col-sm-12 col-xl-12 mb--20">
              <div className="contact-m__single topy-tilt fade-top">
                <div className="content">
                  <h4>Phone</h4>
                  <p>
                    <a href="tel:+919034050507">+91 9034050507</a>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-xl-12 mb--20">
              <div className="contact-m__single topy-tilt fade-top">
                <div className="content">
                  <h4>Mail Address</h4>
                  <p>
                    <a href="mailto:info@manikarndigital.com">info@manikarndigital.com</a>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-xl-12">
              <div className="contact-m__single topy-tilt fade-top">
                <div className="content">
                  <h4>Our Location</h4>
                  <p>
                    <a href="#">#37, Village Khuddi, Ambala Cantt</a>
                  </p>
                </div>
              </div>
            </div>
        </div>

                {/* Form */}
                <div className="col-lg-8 order-1 order-lg-2 img-wrapper d-block text-center mb_sm--20">   
                    <div className="contact-main__form fade-top">


          <div className="content-wrapper">
            <span className="sub-title">Manikarn Digital</span>
            <h2 className="title mt--15 mb--20 mt_sm--10 mb_sm--10">Leave A Message</h2>
          </div>

                      {success && <p style={{ color: "green" }}>{success}</p>}
                      {error && <p style={{ color: "red" }}>{error}</p>}

                      <form onSubmit={handleSubmit} className="section__content-cta">
                        <div className="group-wrapper">
                          <div className="group-input">
                            <input
                              type="text"
                              name="name"
                              placeholder="Your Name"
                              value={formData.name}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <div className="group-input">
                            <input
                              type="tel"
                              name="phone"
                              placeholder="Phone Number with Country Code"
                              value={formData.phone}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>

                        <div className="group-wrapper">
                          <div className="group-input">
                            <input
                              type="email"
                              name="email"
                              placeholder="Email"
                              value={formData.email}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <div className="group-input">
                            <input
                              type="text"
                              name="services"
                              placeholder="Services You Want"
                              value={formData.services}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>

                        <div className="group-input">
                          <textarea
                            name="message"
                            placeholder="Message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div className="form-cta justify-content-start">
                          <button type="submit" className="btn btn--primary" disabled={loading}>
                            {loading ? "Sending..." : "Send Message"}
                          </button>
                        </div>
                      </form>
                    </div>
                </div>
                {/* END Form */}
      </div>
      </div>



        </div>
  </div>
{/* ==== / banner end ==== */}


        </div>
      </section>
      {/* ==== / contact end ==== */}
    </>
  );
};

export default Contact;
